<template>
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="leavePopup">
      <div class="body">
        <div class="close">
          <img
            @click="$emit('close')"
            src="../assets/Icons/close-white.svg"
            alt="close"
          />
        </div>
        <p class="title">{{ $t("result.zeker_afsluiten") }}</p>
        <button class="btn-save" @click="saveSelection">
          <div>{{ $t("result.selectie_later") }}</div>
          <img src="../assets/Icons/arrow-white.svg" />
        </button>
        <button class="btn-noSave" @click="noSave">
          {{ $t("result.afsluiten_zonder_opslaan") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapMutations } from "vuex";
// export default {
//   props: {
//     to: String,
//   },
//   methods: {
//     saveSelection() {
//       this.close();
//       this.resetChanges();
//       this.saveForLater();
//       this.$router.push("/selectie/geefnaam");
//     },
//     noSave() {
//       this.resetGroups();
//       this.$router.push({ path: this.to });
//       this.close();
//     },
//     ...mapMutations("leavePopup", ["close"]),
//     ...mapMutations("baseRef", ["saveForLater", "resetGroups", "resetChanges"]),
//   },
// };

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { defineProps } from "vue";

export default {
  name: "YourComponentName",
  setup() {
    // Define props using defineProps
    const props = defineProps({
      to: {
        type: String,
        required: true,
      },
    });

    // Use Vuex store
    const store = useStore();
    // Use Vue Router
    const router = useRouter();

    // Define methods
    const saveSelection = () => {
      store.commit("leavePopup/close");
      store.commit("baseRef/resetChanges");
      store.commit("baseRef/saveForLater");
      router.push("/selectie/geefnaam");
    };

    const noSave = () => {
      store.commit("baseRef/resetGroups");
      router.push({ path: props.to });
      store.commit("leavePopup/close");
    };

    // Return the methods so they can be used in the template
    return {
      saveSelection,
      noSave,
    };
  },
};
</script>

<style lang="sass" scoped>
.modal-mask
  position: fixed
  z-index: 10001
  top: 50px
  left: 0
  right: 0
  bottom: 90px
  background-color: rgba(15, 18, 19, 0.8)
  .leavePopup
    position: absolute
    display: flex
    justify-content: center
    left: 0
    right: 0
    margin: 0 auto
    top: 25%
    width: 470px
    height: 311px
    color: $black
    z-index: 100000
    .body
      display: flex
      flex-direction: column
      background-color: $grey
      height: 311px
      width: 100%
      box-sizing: border-box
      color: $white
      box-shadow: 0 2px 10px 0 rgba(0,0,0,0.5)
      border-radius: 10px
      align-items: center
      .close
        display: flex
        justify-content: flex-end
        width: 100%
        img
          padding-top: 10px
          padding-right: 10px
          &:hover
            cursor: pointer
      p
        margin: 0
      .title
        font-size: 28px
        line-height: 38px
        font-weight: normal
        text-align: center
        margin-bottom: 40px
        width: 70%
      .btn-save
        height: 45px
        width: 75%
        display: flex
        align-items: center
        font-weight: 500
        font-size: 15px
        line-height: 20px
        text-align: center
        border-radius: 22.5px
        background-color: $red
        color: $white
        border: none
        &:hover
          background-color: #CA3233
        div
          width: 94%
          padding-left: 10px
          margin-right: -25px
      .btn-noSave
        display: flex
        justify-content: center
        width: 75%
        height: 20px
        font-size: 15px
        line-height: 20px
        font-weight: 500
        color: $white
        background-color: transparent
        border: none
        margin-top: 30px
        text-align: center

@media only screen and (min-width: 500px)
  .areYouSurePopup
    width: 470px
    margin: 0 auto
    .body
      .btn-save
        font-size: 15px
</style>
